import React from 'react'
import Icon from 'components/elements/Icon'
import { useRouter } from 'next/router'
import { useCookies } from 'react-cookie'

import { imageDirectory } from 'environment'

import PageWrapper from 'components/misc/PageWrapper'
import CardBanner from 'components/misc/CardBanner'
import InlineAd from 'components/advertisments/InlineAd'
import NewThreadForm from 'components/forumPage/NewThreadForm'
import Link from 'components/elements/Link'

import styles from './new.module.scss'

const NewThreadPage = () => {
  const [{ tbId: userId }] = useCookies(['tbId'])

  const router = useRouter()
  const section = `${router.query.section || 'General'}`

  const title = (
    <p>
      <Icon name="comments outline" /> Create Thread
    </p>
  )

  return (
    <PageWrapper>
      <CardBanner
        src={`${imageDirectory}ths/46febc5d-1625-4e48-bb3f-31ee06fc13dd_art_crop.jpg`}
        height="250px"
        artist
        title={title}
      />

      <div className={styles.content}>
        <InlineAd id="comments-top" banner longBanner renderVisibleOnly={false} />

        <div className={styles.row}>
          <a
            className={styles.discordButton}
            href="https://discord.gg/GyAAANU8uJ"
            rel="noopener noreferrer"
            target="_blank">
            <Icon name="discord" />
            Don't want to wait? Ask on Discord
          </a>
        </div>

        {!!userId && <NewThreadForm category="General" section={section} />}
        {!userId && (
          <div>
            You can't create a thread without an account! <Link href="/login">Click here</Link> to login or make an
            account!
          </div>
        )}
      </div>
    </PageWrapper>
  )
}

export default NewThreadPage
